import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Chapters"] */ "/home/will/Documents/Business/wise/repos/wise/site/app/(app)/academy/videos/[slug]/components/Chapters.tsx");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/about/images/raypoynter.webp");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/about/images/willpoynter.webp");
;
import(/* webpackMode: "eager" */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/components/StyledText.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["StyledText"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/layout/components/StyledText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PurchaseOptions"] */ "/home/will/Documents/Business/wise/repos/wise/site/domains/videos/components/PurchaseOptions.tsx");
